const _0x8465f=_0x55b5;(function(_0x37e861,_0x3ed89b){const _0x50f206=_0x55b5,_0x129bc5=_0x37e861();while(!![]){try{const _0x13b2ae=parseInt(_0x50f206(0x194))/0x1+parseInt(_0x50f206(0x1d6))/0x2+parseInt(_0x50f206(0x1e7))/0x3+parseInt(_0x50f206(0x16f))/0x4*(-parseInt(_0x50f206(0x174))/0x5)+parseInt(_0x50f206(0x1d9))/0x6+parseInt(_0x50f206(0x198))/0x7*(-parseInt(_0x50f206(0x17c))/0x8)+parseInt(_0x50f206(0x1bb))/0x9*(-parseInt(_0x50f206(0x1db))/0xa);if(_0x13b2ae===_0x3ed89b)break;else _0x129bc5['push'](_0x129bc5['shift']());}catch(_0xff53ee){_0x129bc5['push'](_0x129bc5['shift']());}}}(_0x1670,0x53d62));import{Amplify,Auth}from'aws-amplify';import _0x275f83 from'axios';import _0x2011d6 from'pako';import{IsProd,isLocal}from'@/constants/config';import{RSAEncrypt,encrypt,generateEncryptionKey}from'./encryption';import{BusinessError,NetworkError}from'./error';import{hostApi}from'./host';function _0x1670(){const _0x58ed27=['getJwtToken','payment_session','headers','ciphered_data_v4','get_alert','routes_calendar','baseURL','routes_data','8442jlaXkP','task_crawler','assign','length','payload','status','search_result','user_login','join','split','removeItem','alert_check_update','User\x20is\x20not\x20authenticated','ciphered_data_v2','storage_store','add_alert','routes_sample','reverse','routes_refresh','record_flights','log','X-Unique-Id','routes_vote','user_modify_multicity_code','routes_check','user_delete_multicity_code','error:\x20','744850bxXPmy','user_account_usage','string','2457882WiYuoJ','delete_alert','580MPXkNP','user_activities','user_set_preference','now','error','get_alert_usage','user_referee_map','routes_nu_programs','user_daily_limit','https://apiv6.awardtool.com','alert_cache_data','routes_special_flight-','522123ocLmoJ','user_set_email_preference','modify_alert','data','routes_recommend','request','record_id','api_usage','ciphered_data','ciphered_data_v3','use','user_api_usage','storage_add','82036SojRHA','replace','alert_modify','user_search_history','url','85PbIHgS','currentSession','alert_status','jti','alert_add','routes_data-','search_panorama_refresh','parse','16mMUMSP','bb330584-62dd-4b55-8af3-cd4f346ba463','record_deals','user_info','random','jwtToken','create','alert_view_update','currentAuthenticatedUser','storage_get','Authentication','routes_deal','https://dolphin-app-jptdm.ondigitalocean.app/api_main','setItem','toString','getIdToken','hotel_calendar','get_alerts','ZazkH4wK','slice','routes_calendar_v2','https://www.awardtool-api.com/api/','RequestUniqueId','signInUserSession','140176XnFfHt','alert_viewed','http://0.0.0.0:80','user_email_preference','1224433KrJRvI','response','from','hotel_auto_complete','change_alert_status','routes_all','task_crawler_v2','message','fromCharCode','id_','ciphered_data_v5','record_first_class','alert_usage','alert_mode','HEAD','alert_all','alert_search_history','hotel_all','originData','includes','signOut','reject','auth','alert_delete','routes_deal-','seatmap_v2','filter'];_0x1670=function(){return _0x58ed27;};return _0x1670();}function generateUUID(){const _0x437e30=_0x55b5,_0x42ea16='xxxxxxxx-xxxx-hxxx-yxxx-xxxxxxxxxxxx'[_0x437e30(0x170)](/[xy]/g,function(_0x2ce298){const _0x15c614=Math['random']()*0x10|0x0,_0x1d06d2=_0x2ce298==='x'?_0x15c614:_0x15c614&0x3|0x8;return _0x1d06d2['toString'](0x10);});return _0x42ea16;}const request=_0x275f83[_0x8465f(0x182)]({'baseURL':hostApi,'timeout':0x3e8*0x3e8});request['interceptors'][_0x8465f(0x1ec)][_0x8465f(0x1f1)](async _0x14a84f=>{const _0x39180e=_0x8465f,_0x42b6f2=_0x14a84f[_0x39180e(0x173)],_0x2f9b62=[_0x39180e(0x17f),'record_',_0x39180e(0x172),_0x39180e(0x1f2),_0x39180e(0x16e),_0x39180e(0x1c9),_0x39180e(0x185),_0x39180e(0x1ee),'record_routes',_0x39180e(0x185),_0x39180e(0x1ce),'record_mega','record_refresh',_0x39180e(0x17e),_0x39180e(0x1a3),_0x39180e(0x1d7),'storage_get_all',_0x39180e(0x1ca),_0x39180e(0x178),'alert_all','get_alert',_0x39180e(0x1af),_0x39180e(0x171),'alert_status',_0x39180e(0x183),_0x39180e(0x18d),_0x39180e(0x1da),'alert_add',_0x39180e(0x171),'add_alert',_0x39180e(0x178),_0x39180e(0x1a7),_0x39180e(0x1b7),'alert_delete',_0x39180e(0x171),_0x39180e(0x176),_0x39180e(0x183),_0x39180e(0x18d),_0x39180e(0x1da),_0x39180e(0x195),_0x39180e(0x1a4),'alert_mode','alert_cache_data',_0x39180e(0x1a8),_0x39180e(0x1e9),_0x39180e(0x19c),_0x39180e(0x1e0),'alert_check_update','alert_viewed','alert_usage',_0x39180e(0x1a5),_0x39180e(0x1e5),_0x39180e(0x1a8),_0x39180e(0x1c2),_0x39180e(0x1ae),'user_info',_0x39180e(0x1dd),'user_send_invitation',_0x39180e(0x1e1),_0x39180e(0x197),_0x39180e(0x1e8),_0x39180e(0x1dc),_0x39180e(0x1e3),_0x39180e(0x1d2),_0x39180e(0x1d4),_0x39180e(0x1e9),_0x39180e(0x19c),_0x39180e(0x1e0),_0x39180e(0x1c6),_0x39180e(0x1a9),_0x39180e(0x18c),'hotel_book',_0x39180e(0x19b),_0x39180e(0x1b4),'payment_portal','payment_subs_status',_0x39180e(0x1e2),'seatmap',_0x39180e(0x1b1),_0x39180e(0x1bc),_0x39180e(0x19e),_0x39180e(0x1ba),_0x39180e(0x187),'routes_special_flight','routes_refresh_day_route',_0x39180e(0x1d1),_0x39180e(0x1d3),_0x39180e(0x1cd),_0x39180e(0x1eb),_0x39180e(0x19d),_0x39180e(0x1b8),_0x39180e(0x190),_0x39180e(0x1cb)],_0x267289=_0x2f9b62['some'](_0x76db37=>_0x42b6f2?.[_0x39180e(0x1ab)](_0x76db37)),_0x2b663b=_0x39180e(0x1e4);if(IsProd)_0x14a84f['baseURL']=_0x2b663b,_0x267289&&(_0x14a84f[_0x39180e(0x1b9)]='https://apisv2.awardtoolapi.com/api/');else{_0x14a84f[_0x39180e(0x1b9)]=_0x39180e(0x196);try{const _0x2526ea=await fetch('http://0.0.0.0:80/',{'method':_0x39180e(0x1a6),'signal':AbortSignal['timeout'](0x7d0)});!_0x2526ea['ok']&&(_0x14a84f[_0x39180e(0x1b9)]=_0x39180e(0x188));}catch(_0x4d61a1){_0x14a84f[_0x39180e(0x1b9)]='https://dolphin-app-jptdm.ondigitalocean.app/api_main';}}if(_0x42b6f2?.[_0x39180e(0x1ab)](_0x39180e(0x1b0))||_0x42b6f2?.[_0x39180e(0x1ab)](_0x39180e(0x179))||_0x42b6f2?.[_0x39180e(0x1ab)](_0x39180e(0x1e6))){const _0x5863b2=_0x42b6f2['split']('-'),_0x2be7ae=parseInt(_0x5863b2[0x1]);_0x2be7ae>=0x5&&(_0x14a84f[_0x39180e(0x1b9)]=_0x2b663b);}(_0x14a84f[_0x39180e(0x1b9)]==='http://0.0.0.0:80'||_0x14a84f[_0x39180e(0x1b9)]===_0x39180e(0x188))&&(_0x42b6f2?.['includes'](_0x39180e(0x17a))&&(_0x14a84f['baseURL']=_0x39180e(0x191)));let _0x5226f6,_0xb65e80;try{_0x5226f6=await Auth[_0x39180e(0x184)]();const _0x46a18f=await Auth[_0x39180e(0x175)]();_0xb65e80=_0x46a18f[_0x39180e(0x18b)]()[_0x39180e(0x1b3)](),_0x14a84f[_0x39180e(0x1b5)][_0x39180e(0x186)]=_0xb65e80;}catch(_0x52b446){_0x5226f6=null,console[_0x39180e(0x1df)](_0x52b446);}let _0x27e6b1=localStorage['getItem'](_0x39180e(0x192));if(!_0x27e6b1){_0x27e6b1=_0x39180e(0x1a1)+Math[_0x39180e(0x180)]()[_0x39180e(0x18a)](0x24);const _0x2a50c4=new Date()['toISOString']();_0x27e6b1+='@'+_0x2a50c4,localStorage[_0x39180e(0x189)](_0x39180e(0x192),_0x27e6b1);}_0x14a84f[_0x39180e(0x1b5)][_0x39180e(0x1d0)]=_0x27e6b1;const _0x19cc1c=Object[_0x39180e(0x1bd)](_0x14a84f?.['data']??{},{'request_time':Date['now'](),'cipher_data':!![]});console[_0x39180e(0x1cf)](_0x39180e(0x1aa),_0x19cc1c);const _0x5cac56=Math[_0x39180e(0x180)]()['toString']()[_0x39180e(0x18f)](-0x2),_0x1d7cf7=Math[_0x39180e(0x180)]()[_0x39180e(0x18a)]()[_0x39180e(0x18f)](-0x2),_0x5ce502=_0x5226f6?_0x5226f6[_0x39180e(0x193)]['idToken'][_0x39180e(0x1bf)][_0x39180e(0x177)]['slice'](0x0,0x8):_0x39180e(0x18e),_0x244571='12345678910111'+_0x5cac56,_0x1890f4=_0x5cac56+''+_0x1d7cf7+encrypt(_0x19cc1c,_0x244571),_0x5b319b=_0x5cac56+''+_0x1d7cf7+encrypt(_0x19cc1c,_0x244571,_0x5ce502),_0x416f71=RSAEncrypt({'request_time':Date['now'](),'version':0x1,'short_key':_0x39180e(0x17d)},0x0),_0x412cbb=generateEncryptionKey(0x4),_0x1c4e34=0x1,_0x3f9ad3=_0x412cbb+_0x1c4e34+RSAEncrypt({'time':Date[_0x39180e(0x1de)](),'version':0x1,'sk':_0x39180e(0x17d),'record_id':_0x19cc1c?.[_0x39180e(0x1ed)],'uuid':'request_'+generateUUID()},_0x1c4e34);if(_0x14a84f[_0x39180e(0x173)]?.[_0x39180e(0x1ab)](_0x39180e(0x1c1)))_0x14a84f['data']={'ciphered_request':encrypt(_0x19cc1c),'ciphered_requestV2':_0x1890f4,'ciphered_requestV5':_0x5b319b,'ciphered_requestV6':_0x416f71,'ciphered_requestV7':_0x3f9ad3,'request_time':Date[_0x39180e(0x1de)](),'path':_0x42b6f2};else!![]?_0x14a84f[_0x39180e(0x1ea)]={'ciphered_requestV2':_0x1890f4,'ciphered_requestV5':_0x5b319b,'ciphered_requestV6':_0x416f71,'ciphered_requestV7':_0x3f9ad3,'request_time':Date[_0x39180e(0x1de)](),'path':_0x42b6f2}:_0x14a84f[_0x39180e(0x1ea)]={..._0x19cc1c,'ciphered_requestV2':_0x1890f4,'ciphered_requestV5':_0x5b319b,'ciphered_requestV6':_0x416f71,'ciphered_requestV7':_0x3f9ad3};return _0x14a84f;});function recoverString(_0x27f026){const _0x29f130=_0x8465f;let _0x2cee01='';for(let _0x2d3e96=0x0;_0x2d3e96<_0x27f026[_0x29f130(0x1be)];_0x2d3e96++){_0x2cee01+=String[_0x29f130(0x1a0)](_0x27f026['charCodeAt'](_0x2d3e96)-0x1);}const _0x5ef493=_0x2cee01[_0x29f130(0x1c4)]('')[_0x29f130(0x1cc)]()[_0x29f130(0x1c3)]('');return _0x5ef493;}function _0x55b5(_0x4a31cc,_0x37f4b6){const _0x1670e4=_0x1670();return _0x55b5=function(_0x55b566,_0x4818e9){_0x55b566=_0x55b566-0x16e;let _0x2adc57=_0x1670e4[_0x55b566];return _0x2adc57;},_0x55b5(_0x4a31cc,_0x37f4b6);}function recoverInsertedString(_0x1a0d09){const _0x5d9caa=_0x8465f;return _0x1a0d09[_0x5d9caa(0x1c4)]('')[_0x5d9caa(0x1b2)]((_0x6854df,_0x2dbc19)=>_0x2dbc19<0x5||_0x2dbc19>=0xa)[_0x5d9caa(0x1c3)]('');}function recoverStringV5(_0x3d7bdc){const _0xf799ca=_0x8465f,_0x9b3c00=_0x3d7bdc[_0xf799ca(0x1c4)]('')[_0xf799ca(0x1cc)]()[_0xf799ca(0x1c3)]('');return atob(_0x9b3c00);}request['interceptors'][_0x8465f(0x199)][_0x8465f(0x1f1)](_0x141c73=>{const _0x5836ff=_0x8465f;let _0x991a22=null;_0x141c73['data'][_0x5836ff(0x1a2)]&&(_0x141c73['data'][_0x5836ff(0x1b6)]=recoverStringV5(_0x141c73[_0x5836ff(0x1ea)]['ciphered_data_v5']));_0x141c73[_0x5836ff(0x1ea)]['ciphered_data_v4']&&(_0x141c73['data'][_0x5836ff(0x1f0)]=recoverInsertedString(_0x141c73[_0x5836ff(0x1ea)][_0x5836ff(0x1b6)]));_0x141c73[_0x5836ff(0x1ea)]['ciphered_data_v3']&&(_0x141c73[_0x5836ff(0x1ea)]['ciphered_data_v2']=recoverString(_0x141c73[_0x5836ff(0x1ea)][_0x5836ff(0x1f0)]));if(_0x141c73[_0x5836ff(0x1ea)]['ciphered_data_v2'])_0x991a22=_0x141c73['data'][_0x5836ff(0x1c8)][_0x5836ff(0x170)](/[abyh]/g,function(_0x1f6368){switch(_0x1f6368){case'a':return'b';case'b':return'a';case'y':return'h';case'h':return'y';default:return _0x1f6368;}});else _0x141c73[_0x5836ff(0x1ea)][_0x5836ff(0x1ef)]&&(_0x991a22=_0x141c73[_0x5836ff(0x1ea)]['ciphered_data']);if(_0x991a22)try{const _0x4d4eaf=Uint8Array[_0x5836ff(0x19a)](atob(_0x991a22),_0x3a5fc8=>_0x3a5fc8['charCodeAt'](0x0)),_0x23d3ae=_0x2011d6['inflate'](_0x4d4eaf,{'to':_0x5836ff(0x1d8)}),_0x17ba80=JSON[_0x5836ff(0x17b)](_0x23d3ae);_0x141c73[_0x5836ff(0x1ea)]=_0x17ba80,!IsProd&&console[_0x5836ff(0x1cf)]('jsonObject:\x20',_0x17ba80);}catch(_0x384fe9){console[_0x5836ff(0x1cf)](_0x5836ff(0x1d5),_0x384fe9);}_0x141c73[_0x5836ff(0x1ea)]['status']===0x6c7f1&&(console[_0x5836ff(0x1df)](_0x5836ff(0x1c7)),Auth[_0x5836ff(0x1ac)](),localStorage[_0x5836ff(0x1c5)](_0x5836ff(0x181)),localStorage['clear']());if(_0x141c73[_0x5836ff(0x1ea)][_0x5836ff(0x1c0)]===0xc8)return _0x141c73[_0x5836ff(0x1ea)];return Promise[_0x5836ff(0x1ad)](new BusinessError(_0x141c73[_0x5836ff(0x1ea)][_0x5836ff(0x19f)],_0x141c73[_0x5836ff(0x1ea)][_0x5836ff(0x1c0)],_0x141c73[_0x5836ff(0x1ea)]));},_0x410430=>{const _0xfcb434=_0x8465f;return Promise['reject'](new NetworkError(_0x410430[_0xfcb434(0x19f)]));});export default request;

// // // https://obfuscator.io/
// import { Amplify, Auth } from "aws-amplify";
// import axios from "axios";
// import pako from "pako";

// import { IsProd, isLocal } from "@/constants/config";

// import { RSAEncrypt, encrypt, generateEncryptionKey } from "./encryption";
// import { BusinessError, NetworkError } from "./error";
// import { hostApi } from "./host";

// function generateUUID() {
//     const uuid = "xxxxxxxx-xxxx-hxxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
//         const r = (Math.random() * 16) | 0;
//         const v = c === "x" ? r : (r & 0x3) | 0x8;
//         return v.toString(16);
//     });
//     return uuid;
// }

// const request = axios.create({
//     baseURL: hostApi,
//     timeout: 1000 * 1000,
// });

// request.interceptors.request.use(async (config) => {
//     // Get the path of the request
//     const path = config.url;
//     const target_suffix = ["user_info", "record_", "user_search_history",
//         'user_api_usage', 'storage_add', 'storage_store', 'storage_get', 'api_usage', 'record_routes', 'storage_get',
//         'record_flights', 'record_mega', 'record_refresh', 'record_deals', 'record_first_class', 'user_account_usage',
//         'storage_get_all', 'add_alert', 'alert_add', 'alert_all', 'get_alert',
//         'alert_delete', 'alert_modify', 'alert_status',
//         'alert_view_update', 'get_alerts', 'delete_alert', 'alert_add', 'alert_modify', 'add_alert', 'alert_add', 'alert_all', 'get_alert',
//         'alert_delete', 'alert_modify', 'alert_status',
//         'alert_view_update', 'get_alerts', 'delete_alert',
//         'alert_viewed', 'alert_usage', 'alert_mode',
//         'alert_cache_data', 'alert_search_history',
//         'modify_alert', 'change_alert_status', 'get_alert_usage', 'alert_check_update',
//         'alert_viewed', 'alert_usage', 'alert_mode',
//         'alert_cache_data', 'alert_search_history', 'user_login', "auth",
//         "user_info", "user_set_preference", "user_send_invitation", "user_referee_map",
//         "user_email_preference", "user_set_email_preference", "user_activities", "user_daily_limit",
//         "user_modify_multicity_code", "user_delete_multicity_code",
//         'modify_alert', 'change_alert_status', 'get_alert_usage', 'alert_check_update',
//         'hotel_all', 'hotel_calendar', 'hotel_book', 'hotel_auto_complete',
//         'payment_session', 'payment_portal', 'payment_subs_status', "routes_nu_programs",
//         "seatmap", "seatmap_v2", "task_crawler", "task_crawler_v2",
//         "routes_data", "routes_deal", "routes_special_flight", "routes_refresh_day_route", "routes_vote",
//         "routes_check", "routes_refresh", "routes_recommend", 'routes_all', 'routes_calendar', 'routes_calendar_v2', 'routes_sample',]
//     // Check if the target_suffix is in the path array
//     const isTarget = target_suffix.some((suffix) => path?.includes(suffix));
//     const gcpUrl = "https://apiv6.awardtool.com"

//     // Check if current domain contains feature or localhost and not www
//     if (IsProd) {
//         config.baseURL = gcpUrl;
//         if (isTarget) {
//             config.baseURL = "https://apisv2.awardtoolapi.com/api/";
//             // config.baseURL = "https://apiv6.awardtool.com"
//         }


//     } else {
//         // Try local server first, fallback to DigitalOcean if no response
//         config.baseURL = "http://0.0.0.0:80";

//         // Add a check to verify if local server is accessible
//         try {
//             const localServerCheck = await fetch("http://0.0.0.0:80/", {
//                 method: 'HEAD',
//                 signal: AbortSignal.timeout(2000) // 1 second timeout
//             });
//             if (!localServerCheck.ok) {
//                 config.baseURL = "https://dolphin-app-jptdm.ondigitalocean.app/api_main";
//             }
//         } catch (error) {
//             // If local server is not accessible, use DigitalOcean
//             config.baseURL = "https://dolphin-app-jptdm.ondigitalocean.app/api_main";
//         }
//     }

//     // config.baseURL = "https://apiv6.awardtool.com"

//     // If the path contains routes_deal- or routes_data- and the version is 4 or higher, use lambda endpoint
//     if (path?.includes("routes_deal-") || path?.includes("routes_data-") || path?.includes("routes_special_flight-")) {
//         const split = path.split("-");
//         const version = parseInt(split[1]);
//         if (version >= 5) {
//             // config.baseURL = "https://4u73oaqecsys3vkik2p2gxhh4i0pfuow.lambda-url.us-east-1.on.aws/";
//             config.baseURL = gcpUrl;
//         }
//         // if (version >= 4) {
//         //   config.baseURL = "https://www.awardtool-api.com/api/";
//         // }
//     }



//     // If the path contains search_panorama_refresh, use production endpoint
//     if (config.baseURL === "http://0.0.0.0:80" || config.baseURL === "https://dolphin-app-jptdm.ondigitalocean.app/api_main") {
//         if (path?.includes("search_panorama_refresh")) {
//             config.baseURL = "https://www.awardtool-api.com/api/";
//         }
//     }



//     // config.baseURL = "https://www.awardtool-api.com/api/";
//     let user;
//     let authentication;
//     try {
//         user = await Auth.currentAuthenticatedUser();
//         const session = await Auth.currentSession();
//         authentication = session.getIdToken().getJwtToken();
//         config.headers.Authentication = authentication;
//     } catch (error) {
//         // If there is an error, we will log it and set the user to null
//         user = null;
//         console.error(error);
//     }

//     // Set the unique id to the request header
//     // Retrieve the unique id from localstorage, if there is none, generate one and put it in localstorage
//     let uniqueId = localStorage.getItem("RequestUniqueId");
//     if (!uniqueId) {
//         uniqueId = "id_" + Math.random().toString(36);
//         // Append it with generate time
//         const generateTime = new Date().toISOString();
//         uniqueId += `@${generateTime}`;
//         // Save it to localstorage
//         localStorage.setItem("RequestUniqueId", uniqueId);
//     }
//     // Add it to the request header
//     config.headers["X-Unique-Id"] = uniqueId;

//     const originData = Object.assign(config?.data ?? {}, {
//         request_time: Date.now(),
//         cipher_data: true,
//     });

//     console.log("originData", originData);

//     // Randomly generate a encryption key like 1234567891011120
//     const randomKey = Math.random().toString().slice(-2);
//     const randomKey2 = Math.random().toString().slice(-2);
//     const randomKey3 = user ? user.signInUserSession.idToken.payload.jti.slice(0, 8) : "ZazkH4wK";
//     const en_vi = "12345678910111" + randomKey;

//     // Cipher the request data in different ways
//     const ciphered_requestV2 = randomKey + "" + randomKey2 + encrypt(originData, en_vi);
//     const ciphered_requestV5 = randomKey + "" + randomKey2 + encrypt(originData, en_vi, randomKey3);
//     const ciphered_requestV6 = RSAEncrypt(
//         {
//             request_time: Date.now(),
//             version: 1,
//             short_key: "bb330584-62dd-4b55-8af3-cd4f346ba463",
//         },
//         0
//     );

//     // Generate a random number between 0 and 3
//     // Randomly generate a encryption key with alphabet and number
//     const randomStr = generateEncryptionKey(4);
//     const randomNumber = 1;
//     const ciphered_requestV7 =
//         randomStr +
//         randomNumber +
//         RSAEncrypt(
//             {
//                 time: Date.now(),
//                 version: 1,
//                 sk: "bb330584-62dd-4b55-8af3-cd4f346ba463",
//                 record_id: originData?.record_id,
//                 uuid: "request_" + generateUUID(),
//             },
//             randomNumber
//         );

//     if (config.url?.includes("search_result")) {
//         config.data = {
//             // ...originData,
//             ciphered_request: encrypt(originData),
//             ciphered_requestV2: ciphered_requestV2,
//             ciphered_requestV5: ciphered_requestV5,
//             ciphered_requestV6: ciphered_requestV6,
//             ciphered_requestV7: ciphered_requestV7,
//             request_time: Date.now(),
//             path: path,
//             // authentication: authentication,
//         };
//         // } else if (!isLocal) {
//     } else if (true) {
//         config.data = {
//             // ...originData,
//             ciphered_requestV2: ciphered_requestV2,
//             ciphered_requestV5: ciphered_requestV5,
//             ciphered_requestV6: ciphered_requestV6,
//             ciphered_requestV7: ciphered_requestV7,
//             request_time: Date.now(),
//             path: path,
//             // authentication: authentication,
//         };
//     } else {
//         config.data = {
//             ...originData,
//             ciphered_requestV2: ciphered_requestV2,
//             ciphered_requestV5: ciphered_requestV5,
//             ciphered_requestV6: ciphered_requestV6,
//             ciphered_requestV7: ciphered_requestV7,
//         };
//     }

//     return config;
// });

// function recoverString(messedUpString) {
//     // Shift each character back
//     let shiftedString = "";
//     for (let i = 0; i < messedUpString.length; i++) {
//         shiftedString += String.fromCharCode(messedUpString.charCodeAt(i) - 1);
//     }

//     // Reverse the string to get the original
//     const originalString = shiftedString.split("").reverse().join("");

//     return originalString;
// }

// function recoverInsertedString(messedUpString) {
//     // Get remove the 5-10th character
//     return messedUpString
//         .split("")
//         .filter((c, i) => i < 5 || i >= 10)
//         .join("");
// }

// function recoverStringV5(obfuscated) {
//     const reversed = obfuscated.split('').reverse().join('');
//     return atob(reversed);  // base64 decode
// }

// request.interceptors.response.use(
//     (res) => {
//         let ciphered_data = null;
//         if (res.data.ciphered_data_v5) {
//             res.data.ciphered_data_v4 = recoverStringV5(res.data.ciphered_data_v5);
//         }
//         if (res.data.ciphered_data_v4) {
//             res.data.ciphered_data_v3 = recoverInsertedString(res.data.ciphered_data_v4);
//         }
//         if (res.data.ciphered_data_v3) {
//             res.data.ciphered_data_v2 = recoverString(res.data.ciphered_data_v3);
//         }
//         if (res.data.ciphered_data_v2) {
//             // console.log("res.data.ciphered_data_v2res.data.ciphered_data_v2")
//             ciphered_data = res.data.ciphered_data_v2.replace(/[abyh]/g, function (match) {
//                 switch (match) {
//                     case "a":
//                         return "b";
//                     case "b":
//                         return "a";
//                     case "y":
//                         return "h";
//                     case "h":
//                         return "y";
//                     default:
//                         return match;
//                 }
//             });
//         } else if (res.data.ciphered_data) {
//             ciphered_data = res.data.ciphered_data;
//         }

//         if (ciphered_data) {
//             try {
//                 const compressedData = Uint8Array.from(atob(ciphered_data), (c) => c.charCodeAt(0));
//                 const decompressedData = pako.inflate(compressedData, { to: "string" });
//                 const jsonObject = JSON.parse(decompressedData);
//                 res.data = jsonObject;
//                 if (!IsProd) {
//                     console.log("jsonObject: ", jsonObject);
//                 }
//             } catch (error) {
//                 console.log("error: ", error);
//             }
//         }

//         if (res.data.status === 444401) {
//             // Logout the user
//             console.error("User is not authenticated");
//             Auth.signOut();
//             localStorage.removeItem("jwtToken");
//             localStorage.clear();
//             // Refresh the page
//             // window.location.href = "/";
//         }

//         if (res.data.status === 200) {
//             return res.data;
//         }



//         return Promise.reject(new BusinessError(res.data.message, res.data.status, res.data));
//     },
//     (error) => {
//         return Promise.reject(new NetworkError(error.message));
//     }
// );

// export default request;
